<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="type" class="form-label fw-bold"
				>Type de restitution</label
			>
			<select
				required
				id="type"
				class="form-select"
				name="type"
				formControlName="type"
				aria-label="Sélectionner un type"
				[ngClass]="{
					'is-invalid': type?.invalid,
					'is-valid': type?.dirty && type?.valid
				}"

			>
				<option [value]="RestitutionTypeEnum.FINALE">Restitution finale</option>
				<option [value]="RestitutionTypeEnum.MOIS3">Information restitution à 3 mois</option>
				<option [value]="RestitutionTypeEnum.MOIS6">Validation restitution à 6 mois</option>
				<option [value]="RestitutionTypeEnum.MOIS9">Information restitution à 9 mois</option>
				<option [value]="RestitutionTypeEnum.MOIS12">Validation restitution à 12 mois</option>
				<option [value]="RestitutionTypeEnum.MOIS15">Information restitution à 15 mois</option>
			</select>
		</div>
	</div>
	
	<div class="row my-4">
		<div *ngIf="form.contains('dateValidQualif')" class="col-12 col-lg">
			<label for="dateValidQualif" class="form-label fw-bold"
				>Date de validation de la qualification</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateValidQualif"
				name="dateValidQualif"
				formControlName="dateValidQualif"
				[isDisabled]="true"
				[ngClass]="{
					'is-invalid': dateValidQualif?.invalid,
					'is-valid': dateValidQualif?.dirty && dateValidQualif?.valid
				}"
			/>
		</div>
		<div *ngIf="form.contains('dateButoirDepot')" class="col-12 col-lg">
			<label for="dateButoirDepot" class="form-label fw-bold"
				>Date butoir pour le dépôt de la restitution</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateButoirDepot"
				name="dateButoirDepot"
				formControlName="dateButoirDepot"
				[ngClass]="{
					'is-invalid': dateButoirDepot.invalid,
					'is-valid': dateButoirDepot.dirty && dateButoirDepot.valid
				}"
			/>
		</div>
	</div>
	<div class="row my-4">
		<div *ngIf="form.contains('dateDepotRestFinale')" class="col-12 col-lg">
			<label for="dateDepotRestFinale" class="form-label fw-bold"
				>Date de dépôt de la restitution</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateDepotRestFinale"
				name="dateDepotRestFinale"
				formControlName="dateDepotRestFinale"
				[ngClass]="{
					'is-invalid': dateDepotRestFinale.invalid,
					'is-valid': dateDepotRestFinale.dirty && dateDepotRestFinale.valid
				}"
			/>
		</div>
	</div>

	<!-- <div class="row my-4">
		<div *ngIf="form.contains('prolongation')" class="col-12 col-lg">
			<label for="prolongation" class="form-label fw-bold"
				>Demande de prolongation de la durée:   </label
			>
			<label class="ms-2 form-check-label text-dark">
				<input type="radio" name="prolongation" formControlName="prolongation" [value]="true" />Oui
			</label>
			<label class="ms-2 form-check-label text-dark">
				<input type="radio" name="prolongation" formControlName="prolongation" [value]="false" />Non
			</label>
		</div>
	</div> -->

	<div class="row my-4">
		<!-- <div *ngIf="form.contains('dateDemarrage')" class="col-12 col-lg">
			<label for="dateDemarrage" class="form-label fw-bold"
				>Date de démarrage</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateDemarrage"
				name="dateDemarrage"
				formControlName="dateDemarrage"
				[isDisabled]="true"
				[ngClass]="{
					'is-invalid': dateDemarrage.invalid,
					'is-valid': dateDemarrage.dirty && dateDemarrage.valid
				}"
			/>
		</div> -->
		<div *ngIf="form.contains('date1erRv')" class="col-12 col-lg">
			<label for="date1erRv" class="form-label fw-bold"
				>Date de 1er rendez-vous bénéficiaire</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="date1erRv"
				name="date1erRv"
				formControlName="date1erRv"
				[ngClass]="{
					'is-invalid': date1erRv.invalid,
					'is-valid': date1erRv.dirty && date1erRv.valid
				}"
			/>
		</div>
	</div>
	<div class="row my-4">
		<div *ngIf="form.contains('dateFinPrev')" class="col-12 col-lg">
			<label for="dateFinPrev" class="form-label fw-bold"
				>Nouvelle date de fin prévisionnelle de réalisation</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateFinPrev"
				name="dateFinPrev"
				formControlName="dateFinPrev"
				[ngClass]="{
					'is-invalid': dateFinPrev.invalid,
					'is-valid': dateFinPrev.dirty && dateFinPrev.valid
				}"
			/>
		</div>
	</div>


	<div class="row my-4">
		<div *ngIf="form.contains('heuresPrev')" class="col-12 col-lg">
			<label for="heuresPrev" class="form-label fw-bold"
				>Heures prévisionnelles de réalisation</label
			>
			<input
				type="number"
				class="form-control"
				formControlName="heuresPrev"
				[readonly] = "true"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('totalHeures')" class="col-12 col-lg">
			<label for="totalHeures" class="form-label fw-bold"
				>Total heures renseignées</label
			>
			<input
				type="number"
				class="form-control"
				formControlName="totalHeures"
				[readonly] = "true"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('heuresBilaterales')" class="col-12 col-lg">
			<label for="heuresBilaterales" class="form-label fw-bold"
				>Dont heures bilatérales avec bénéficiaire</label
			>
			<input
				type="number"
				class="form-control"
				formControlName="heuresBilaterales"
			/>
		</div>

		<div *ngIf="form.contains('heuresCollectif')" class="col-12 col-lg">
			<label for="heuresCollectif" class="form-label fw-bold"
				>Dont heures en collectif</label
			>
			<input
				type="number"
				class="form-control"
				formControlName="heuresCollectif"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('heuresEmployeur')" class="col-12 col-lg">
			<label for="heuresEmployeur" class="form-label fw-bold"
				>Dont heures chez l’employeur/en organisme/Bénéficiaire</label
			>
			<input
				type="number"
				class="form-control"
				formControlName="heuresEmployeur"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('totalHeuresRestantes')" class="col-12 col-lg">
			<label for="totalHeuresRestantes" class="form-label fw-bold"
				>Total heures restantes</label
			>
			<input
				type="number"
				class="form-control"
				formControlName="totalHeuresRestantes"
				[readonly] = "true"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('mobilisationAutreAs')" class="col-12 col-lg">
			<label for="mobilisationAutreAs" class="form-label fw-bold"
				>Mobilisation autre appui spécifique:</label
			>
			<label class="ms-2 form-check-label text-dark">
				<input type="radio" [attr.disabled]="true" name="mobilisationAutreAs" formControlName="mobilisationAutreAs" [value]="true" />Oui
			</label>
			<label class="ms-2 form-check-label text-dark">
				<input type="radio" [attr.disabled]="true" name="mobilisationAutreAs" formControlName="mobilisationAutreAs" [value]="false" />Non
			</label>
		</div>
	</div>

	<div class="row my-4" *ngIf="form.get('mobilisationAutreAs').value">
		<div *ngIf="form.contains('raisonSocialeAutre')" class="col-12 col-lg">
			<label for="raisonSocialeAutre" class="form-label fw-bold"
				>Raison sociale des autres prestataires mobilisés </label
			>
			<input
				id="raisonSocialeAutre"
				class="form-control"
				formControlName="raisonSocialeAutre"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('pointVigilance')" class="col-12 col-lg">
			<label for="pointVigilance" class="form-label fw-bold"
				>Points de vigilance et/ou difficultés rencontrées </label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorPointVigilance"> </ngx-editor-menu>
				<ngx-editor [editor]="editorPointVigilance" formControlName="pointVigilance"></ngx-editor>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('organismePecBenef')" class="col-12 col-lg">
			<label for="organismePecBenef" class="form-label fw-bold"
				>Institution ou organisme assurant déjà une prise en charge du bénéficiaire </label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorOrganismePecBenef"> </ngx-editor-menu>
				<ngx-editor [editor]="editorOrganismePecBenef" formControlName="organismePecBenef"></ngx-editor>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('consequencesHandicap')" class="col-12 col-lg">
			<label for="consequencesHandicap" class="form-label fw-bold"
				>Préciser en quoi les conséquences du handicap amènent à des préconisations en aides techniques, humaines et/ou organisationnelles</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorConsequencesHandicap"> </ngx-editor-menu>
				<ngx-editor [editor]="editorConsequencesHandicap" formControlName="consequencesHandicap"></ngx-editor>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="reponsesIdentifiees" class="form-label fw-bold"
				>Réponses identifiées :</label
			>
			<div class="row">
				<div
					class="col-md-4 check"
					*ngFor="let aide of listAideEnum | keyvalue"
				>
					<div>
						<input
							type="checkbox"
							name="{{ aide.value }}"
							class="form-check-input"
							[value]="aide.key"
							[checked]="isAideCheck(aide.key)"
							[ngClass]="{
								'theme-main-color-check': isAideCheck(aide.key)
							}"
							(change)="updateSelectedAide($event, aide.key)"
						/>
						<label class="ms-2 form-check-label text-dark">
							{{ AideStringEnum[aide.value] }}
						</label>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="listSelectedAide.includes(listAideEnum.AT)" class="row my-4">
		<div *ngIf="form.contains('aidesTechniques')" class="col-12 col-lg">
			<label for="aidesTechniques" class="form-label fw-bold"
				>Préciser du ou des matériels, les démarches réalisées et les points d’attention</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorAidesTechniques"> </ngx-editor-menu>
				<ngx-editor [editor]="editorAidesTechniques" formControlName="aidesTechniques"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="listSelectedAide.includes(listAideEnum.AH)" class="row my-4">
		<div *ngIf="form.contains('aidesHumaines')" class="col-12 col-lg">
			<label for="aidesHumaines" class="form-label fw-bold"
				>Préciser les aides humaines nécessaires </label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorAidesHumaines"> </ngx-editor-menu>
				<ngx-editor [editor]="editorAidesHumaines" formControlName="aidesHumaines"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="listSelectedAide.includes(listAideEnum.AO)" class="row my-4">
		<div *ngIf="form.contains('aidesOrganisationnelles')" class="col-12 col-lg">
			<label for="aidesOrganisationnelles" class="form-label fw-bold"
				>Préciser pour les aides organisationnelles la nature des actions préconisées et les intervenants concernés</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorAidesOrganisationnelles"> </ngx-editor-menu>
				<ngx-editor [editor]="editorAidesOrganisationnelles" formControlName="aidesOrganisationnelles"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="listSelectedAide.includes(listAideEnum.MED)" class="row my-4">
		<div *ngIf="form.contains('mediation')" class="col-12 col-lg">
			<label for="mediation" class="form-label fw-bold"
				>Préciser pour les médiations et/ou interventions la nature des actions préconisées et les intervenants concernés</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorMediation"> </ngx-editor-menu>
				<ngx-editor [editor]="editorMediation" formControlName="mediation"></ngx-editor>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('statutDemandeProlongation')" class="col-12 col-lg">
			<label for="statutDemandeProlongation" class="form-label fw-bold"
				>Demande de prolongation de la durée :  </label
			>
			<label class="ms-2 form-check-label text-dark">
				<input type="radio" name="statutDemandeProlongation" formControlName="statutDemandeProlongation" [value]="StatutProlongationEnum.OBJET" />Est sans objet
			</label>
			<label class="ms-2 form-check-label text-dark">
				<input type="radio" name="statutDemandeProlongation" formControlName="statutDemandeProlongation" [value]="StatutProlongationEnum.DEMANDE" />Est demandé
			</label>
			<label class="ms-2 form-check-label text-dark">
				<input type="radio" name="statutDemandeProlongation" formControlName="statutDemandeProlongation" [value]="StatutProlongationEnum.ACCORDE" />Est accordé
			</label>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('demarcheAdministrative')" class="col-12 col-lg">
			<label for="demarcheAdministrative" class="form-label fw-bold"
				>Démarche administrative à conduire  : </label
			>
			<label class="ms-2 form-check-label text-dark">
				<input type="radio" name="demarcheAdministrative" formControlName="demarcheAdministrative" [value]="true" />Oui
			</label>
			<label class="ms-2 form-check-label text-dark">
				<input type="radio" name="demarcheAdministrative" formControlName="demarcheAdministrative" [value]="false" />Non
			</label>
		</div>
	</div>

	<div *ngIf="form.get('demarcheAdministrative').value" class="row my-4">
		<div *ngIf="form.contains('demarcheAdministrativeDetails')" class="col-12 col-lg">
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorDemarcheAdministrativeDetails"> </ngx-editor-menu>
				<ngx-editor [editor]="editorDemarcheAdministrativeDetails" formControlName="demarcheAdministrativeDetails"></ngx-editor>
			</div>
		</div>
	</div>

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="!form.valid || isValidateButtonClicked.value"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
